import React, {useEffect, useState} from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import Stack from '@mui/material/Stack';

import { NavItem } from './components';
import { Facebook, Instagram, LinkedIn, YouTube } from '@mui/icons-material';
import { red, grey, blue } from '@mui/material/colors';
import XIcon from '@mui/icons-material/X';
import MenuSearchInput from '../../../../components/MenuSearchInput';
import ocpfLogo from '../../../../images//ocpfsmallicon.png';
import { useMediaQuery } from '@mui/material';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSidebarOpen: () => void;
  pages: {
    filers: Array<PageItem>;
    legal: Array<PageItem>;
    reports: Array<PageItem>;
    data: Array<PageItem>;
    forms: Array<PageItem>;
    clerk: Array<PageItem>;
    about: Array<PageItem>;
  };
  colorInvert?: boolean;
}

const Topbar = ({onSidebarOpen,pages,colorInvert = false,}: Props): JSX.Element => {

  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    filers: filersPages,
    legal: legalPages,
    reports: reportsPages,
    data: dataPages,
    forms: formsPages,
    clerk: clerkPages,
    about: aboutPages,
  } = pages;


  const [activeLink, setActiveLink] = useState('');
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    
    const path = window.location.pathname;
    const segments = path.split('/');
    let activeLink = '';

    if (segments.length >= 2) {
      activeLink = segments[0] + '/' + segments[1];
    } else {
      activeLink = path;
    };

    if(activeLink.toLowerCase() === '/home1' || activeLink.toLowerCase() === '/' || activeLink.toLowerCase() === '/home' || activeLink.toLowerCase() === '/index'){
      setIsHomePage(true);
    };

    setActiveLink(window && window.location ? activeLink : '');
  }, []);
  
  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width={1}
    >
      <Box
        display={'flex'}
        component="a"
        href="/"
        title="OCPF"
        width={{ xs: 100, md: 120 }}
      >
        <Box
          component={'img'}
          alt="OCPF Logo"
          title="OCPF"
          aria-label='OCPF Logo'
          src={ocpfLogo}
          height={1}
          width={1}
        />
      </Box>
 
      <Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'}>
        {/*
        <Box marginLeft={2.5}>
          <Link 
            underline="none" 
            component="a" 
            href="/FilerListing" 
            color={"/Filers" == activeLink || "/FilerListing" == activeLink ? 'primary' : 'text.primary'} 
            fontWeight={"/Filers" == activeLink || "/FilerListing" == activeLink? 700 : 400}
          >
            Filers
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Legal"
            color={"/Legal" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Legal" == activeLink ? 700 : 400}
          >
            Legal
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Reports"
            color={"/Reports" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Reports" == activeLink ? 700 : 400}
          >
            Reports
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Data"
            color={"/Data" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Data" == activeLink ? 700 : 400}
          >
            Data
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Publications"
            color={"/Publications" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Publications" == activeLink ? 700 : 400}
          >
            Forms
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Municipal"
            color={"/Municipal" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Municipal" == activeLink ? 700 : 400}
          >
            Clerk
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'About'}
            id={'about-pages'}
            items={aboutPages}
            colorInvert={colorInvert}
          />
        </Box>
        */}
        
        <Box>
          <NavItem
            title={'Filers'}
            id={'filer-pages'}
            items={filersPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Legal'}
            id={'legal-pages'}
            items={legalPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Data'}
            id={'data-pages'}
            items={dataPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Reports'}
            id={'reports-pages'}
            items={reportsPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Forms'}
            id={'forms-pages'}
            items={formsPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Clerks'}
            id={'clerk-pages'}
            items={clerkPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'About'}
            id={'about-pages'}
            items={aboutPages}
            colorInvert={colorInvert}
          />
        </Box>

        {/* social media icons */}
        {
          (isHomePage || activeLink.toLowerCase().includes('search')) &&
          <Box marginLeft={3}>
            <Stack spacing={1} direction="row">
            <a aria-label='Youtube Icon' title='Youtube Icon' href="https://www.youtube.com/user/ocpfreports" target='_blank'>
              <YouTube sx={{ color: red[500] }} />
            </a>
            <a aria-label='Twitter Icon' title='Twitter Icon' href="https://twitter.com/OCPFReports" target='_blank'>
              <XIcon sx={{ color: grey[900] }}  />
            </a>
            <a aria-label='Instagram Icon' title='Instagram Icon' href="https://www.instagram.com/ocpfreports" target='_blank'>
              <Instagram sx={{ color: grey[800] }} />  
            </a>
            <a aria-label='Facebook Icon' title='Facebook Icon' href="https://www.facebook.com/massocpf/" target="_blank">
              <Facebook color="primary" />
            </a>
            {/*
              <a href="https://www.linkedin.com/company/ma-office-of-campaign-and-political-finance/" target='_blank'>
              <LinkedIn sx={{ color: blue[900] }} />  
            </a>
            */}
            </Stack>
          </Box>
        }
        {
          !isHomePage && !activeLink.toLowerCase().includes('search') &&
          <Box marginLeft={3}>
            <MenuSearchInput></MenuSearchInput>
          </Box>
        }
        <Box marginLeft={3}>
          <Button
            variant="contained"
            color="primary"
            component="a"
            target="blank"
            size='small'
            href="https://www.ocpfreporter.us/Account/LogOn"
          >
            Sign In
          </Button>
        </Box>
        <Box marginLeft={2}>
          <Button
            variant="outlined"
            color="primary"
            component="a"
            target="blank"
            size='small'
            href="https://www.ocpfreporter.us/OnlineOrganization/SignUp"
          >
            Register
          </Button>
        </Box>
      </Box>
      <Box sx={{ display: { xs: 'flex', md: 'none' } }} alignItems={'left'}>
        <Stack direction={'row'} spacing={1} marginRight={1}>
            {activeLink.toLowerCase() != '/home1' && !activeLink.toLowerCase().includes('search') &&
              <MenuSearchInput></MenuSearchInput>
            }
            <Button
              variant="outlined"
              size="small"
              color="primary"
              component="a"
              sx={{ paddingTop: 0.8, paddingBottom: 0.8}}
              href="https://www.ocpfreporter.us/">
              Sign In
            </Button>
        </Stack>
        <Button
          onClick={() => onSidebarOpen()}
          aria-label="Menu"
          variant={'outlined'}
          sx={{
            borderRadius: 2,
            minWidth: 'auto',
            padding: 1,
            borderColor: alpha(theme.palette.divider, 0.2),
          }}
        >
          <MenuIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default Topbar;
